const PrivacyBody = () => {
  return (
    <section className="flex flex-col  items-center">
      <div className="flex flex-col my-10 gap-4 p-3 md:p-5 lg:p-10 max-w-[80rem] w-full text-[#667085] text-[1.1rem] font-[500]">
        <div className="text-4xl font-[600] mx-auto text-[#34B3EB]">
          Privacy Policy
        </div>
        <div className="">
          <b>Snappy-fix technologies</b> (“Snappy-fix technologies”, “we” or
          “us”) issue this privacy policy (“Privacy Policy”) to inform you of
          our procedures and policies regarding the collection, disclosure, and
          use of Personal Information Snappy-fix technologies receive or collect
          from users of our application. This Privacy Policy applies to
          information that you provide to us (or permit third party sites to
          provide us) or that we collect through the Services.
        </div>
        <div className="">
          This Privacy Policy will be updated at dates in the future to be
          determined by Snappy-fix technologies. We will notify you of any
          changes by posting the new Privacy Policy on this page. Snappy-fix
          technologies recommend that you consult this Privacy Policy
          periodically for any changes.
        </div>
        <div className="">
          If you do not agree to the terms of this Privacy Policy, please do not
          use the Services.
        </div>
        <div className="text-2xl font-[600] text-[#34B3EB]">
          What This Policy Contains
        </div>
        <div className="">
          <ol type="I">
            <li>
              {" "}
              (I) - Entity Responsible for the Processing of your Personal
              Information
            </li>
            <li>
              (II) - Personal Information Collected and Used, Processing
              Purposes and Legal Bases
            </li>
            <li>(III) - Information Sharing and Disclosure</li>
            <li>(IV) - How Long We Store Your Information</li>
            <li>(V) - Governing Laws</li>
            <li>(VI) - Security</li>
            <li>(VII) - Our Policy Towards Children</li>
            <li>(VIII) - Phishing</li>
            <li>(IX) - Change of Privacy Policy</li>
            <li>(X) - Complaints</li>
            <li>(XI) - Child Safety</li>
          </ol>
        </div>

        <div className="text-2xl font-[600] text-[#34B3EB]">
          I. Entity Responsible for the Processing of your Personal Information
        </div>
        <div className="">
          Snappy-fix technologies (www.snappy-fix.com) is responsible for the
          processing of your personal information in connection with the use of
          our Services.
        </div>

        <div className="text-2xl font-[600] text-[#34B3EB]">
          II. Personal Information Collected and Used, Processing Purposes and
          Legal Bases
        </div>
        <div className="text-2xl font-[600]">Personal Information </div>
        <div className="">
          As you use the Services, you may provide us with information relating
          to an identified or identifiable natural person (“Personal
          Information”). An identifiable natural person is a person who can be
          identified, directly or indirectly. Personal Information includes data
          such as your name, username and email address and password, but is not
          limited to this information. Personal Information may also include
          information about your usage of our Services, financial or
          transactional details, user identifiers or other application specific
          information When you contact our customer support services, this may
          include a record of that correspondence and associated contact
          information.
        </div>
        <div className="text-2xl font-[600]">
          Personal Information That You Provide
        </div>
        <div className="text-sm font-[600]">
          We use this Personal Information with your consent.
        </div>
        <div className="">
          If you choose to subscribe for our Services, we or our third party
          service providers may collect Personal Information from you to
          facilitate your payment. We use this Personal Information to perform
          our contract with you to provide the Services to you.
        </div>

        <div className="">
          We use Personal Information that you provide in connection with your
          registration and/or use of the Services (e.g., your name,email,
          username, password) in order to provide our Services and your user
          account to you. We may also use any Personal Information that you
          include in any inquiry that you send to us. We use the aforementioned
          Personal Information to perform our contract with you to provide the
          Services to you.
        </div>
        <div className="">
          For these services, this includes all or select information stored in
          your accounts and is associated with your login credentials and your
          device. We have no way of accessing or providing decrypted Secure
          data, and we never receive copies of unencrypted Secure data. Your
          secure data is your property. We claim no rights to it beyond those
          necessary to deliver services to you. You may add, modify, and delete
          secure data at your discretion. You are responsible for maintaining
          your credentials and managing access to your secure data, as outlined
          in Section XI.
        </div>
        <div className="text-2xl font-[600]">
          Personal Information We Collect Automatically
        </div>
        <div className="">
          Our Services may require additional Personal Information or
          permissions from your device in order to function effectively.
        </div>
        <div className="">
          Log Data. When you use the Services, as a registered user, for example
          in accessing our Services through mobile application, our servers
          automatically record information that your browser sends whenever you
          visit application (“Log Data”). We use the Log Data to monitor and
          analyze use of the Services, to technically administer and maintain
          the Services, to provide the Services to you, to improve and increase
          the functionality and user-friendliness of our Services, and for
          security purposes. For example, some of the Log Data is collected so
          that when you use our Services again, it will recognize you and will
          make your continued use of the Services easier (e.g. by remembering
          that you are logged into the Services). We also use the Log Data to
          verify that visitors to the Service meet the criteria required to
          process their requests. We use the Log Data to perform our contract
          with you to provide the functioning Services to you.
        </div>
        <div className="text-2xl font-[600]">
          How We Use Your Personal Information:{" "}
        </div>
        <div className="text-sm font-[600]">
          We may use your Personal Information for the following purposes:
        </div>
        <div className="">
          <ul>
            <li>- Providing, Improving, and Developing the Services</li>
            <li>- Provide the Services to you</li>
            <li>- To set up your user account</li>
            <li>
              - Recognize you when you return to our Services, save your
              registration ID and login password for future logins, and store
              information about your use of the Services
            </li>
            <li>- To enable you to subscribe to our Services.</li>
            <li>
              Provide customer service and to respond to any inquiry that you
              send to us
            </li>
            <li>
              - Operate, protect, improve, and optimize the Services and the
              user experience, such as by performing analytics and conducting
              research
            </li>
            <li>
              - Communicate with you and to send you information by personalized
              email, postal mail, telephone, text message, or other means about
              our Services, support messages, updates, security alerts, and
              account notifications.
            </li>
            <li>
              - Make your user experience easier, more personalized, more
              enjoyable and more efficient
            </li>
            <li>
              - Address problems with and improve our Services and technologies,
              as well as to develop new Services
            </li>
            <li>
              - Enable certain features of the Services in order to better
              understand how you interact with the Services and to monitor
              aggregate usage.
            </li>
            <li>- Fulfill your subscription requests and refunds</li>
            <li>
              - Operate, protect, improve, and optimize the Services and
              experience, and personalize and customize your experience. We use
              your Personal Information on the basis of our legitimate interests
              in improving our Services and your experience. With your consent,
              we conduct profiling based on your interactions with the Services.
            </li>
          </ul>
        </div>
        <div className="text-2xl font-[600]">
          Creating and Maintaining a Trusted and Safe Environment
        </div>
        <div className="">
          <ul>
            <li>
              Prevent, detect, mitigate and investigate fraud, security breaches
              and activities that are or potentially may be prohibited or
              illegal
            </li>
            <li>Conduct security investigations and risk assessments</li>
            <li>Verify or authenticate information</li>
            <li>
              As we believe to be required or appropriate to protect the rights,
              property, safety and security of Snappy-fix technologies and our
              employees, customers and others
            </li>
            <li>
              As we believe to be required or appropriate under applicable law,
              to respond to requests from government authorities and to comply
              with legal process, investigations,regulatory or governmental
              inquiries or for other legal or regulatory purposes
            </li>
            <li>Comply with our legal obligations</li>
            <li>
              Resolve any disputes with any of our users and enforce our
              agreements with third parties
            </li>
            <li>Enforce our Terms of Service or other policies.</li>
            <li>
              We use your Personal Information for these purposes given our
              legitimate interest in protecting the Services and to comply with
              applicable laws.
            </li>
          </ul>
        </div>

        <div className="text-2xl font-[600] text-[#34B3EB]">
          III. Information Sharing and Disclosure
        </div>
        <div className="text-2xl font-[600]">Third-party Advertisers</div>
        <div className="">
          We may share aggregated information that does not include Personal
          Information and we may otherwise disclose Non-Identifying Information
          and Log Data with third parties for industry analysis, demographic
          profiling and other purposes.
        </div>
        <div className="">
          In particular, we share Non-Identifying Information (including the
          advertising identifier currently associated with your device) and Log
          Data and other aggregated information with third party advertising and
          technology companies. The data we share with them may include data
          about your device, approximate location, and use of our Applications,
          including IP address, device identifiers and information, Application
          usage data, and purchase data as well as information you provide to us
          when using our Application Such information may be used to send you
          targeted advertisements for products and services that are relevant to
          your interests. In some cases these third parties will also use the
          data that they collect for their own purposes, such as aggregating
          your data with other data they hold in order to inform advertising
          related services provided to other clients. That advertising may
          appear across the Services.{" "}
        </div>
        <div className="">
          For example, we may collect and share the advertising identifier
          associated with your device (such as the Apple IDFA and Android
          Advertising ID) with advertisers. An advertising identifier is an
          alphanumeric string that can be used to identify your device so that
          advertisers can serve relevant ads to you. We use the Apple IDFA only
          as permitted by Apple, and we use the Android Advertising ID only as
          permitted by Google. An advertising identifier is assigned, and ad
          tracking is turned on, by default on your mobile device. You may limit
          the use of or reset your advertising device ID using the privacy
          settings on your mobile device; in some instances you may need to
          reset the operating system to reset the advertising device ID. We do
          not associate any of your personal information with your advertising
          device ID without your consent (which may be given by you in our terms
          of use for an Application).
        </div>
        <div className="">
          We may share your Personal Information with our group companies where
          it in order to provide our Services or customer support to you or
          based on our legitimate interests for internal administrative and
          management purposes (for example, for corporate strategy, compliance,
          auditing and monitoring, research and development, and quality
          assurance).
        </div>
        <div className="">
          Compliance with Laws and Law Enforcement. Snappy-fix technologies
          cooperates with government and law enforcement officials and private
          parties to enforce and comply with the law. We may disclose any
          Personal Information to government or law enforcement officials where
          necessary to respond to any government or law enforcement requests or
          private parties as we, in our sole discretion, believe necessary or
          appropriate to respond to claims and legal process (including but not
          limited to subpoenas), to protect the property and rights of Maple
          Media or a third party, to protect the safety of the public or any
          person, or to prevent or stop activity we may consider to be, or to
          pose a risk of being, any illegal, unethical or legally actionable
          activity.
        </div>
        <div className="">
          Business Transfers. Snappy-fix technologies may sell, transfer or
          otherwise share some or all of its assets, including your Personal
          Information, in connection with a merger, acquisition, reorganization
          or sale of assets or in the event of bankruptcy.
        </div>
        <div className="">
          Other Disclosures. We may share your Personal Information with our
          legal, regulatory, audit, and other professional advisors. Those
          companies may use your Personal Information to assist us in our
          operations consistent with our legitimate business interests.
        </div>
        <div className="text-2xl font-[600] text-[#34B3EB]">
          IV. How Long We Store Your Information
        </div>
        <div className="">
          We keep your Personal Information for no longer than necessary for the
          purposes for which the Personal Information is processed. The length
          of time for which we retain Personal Information depends on the
          purposes for which we collect and use it and/or as required to comply
          with applicable laws and to establish, exercise or defend against
          legal claims.
        </div>
        <div className="text-2xl font-[600] text-[#34B3EB]">
          V. Governing Laws
        </div>
        <div className="">
          The laws of Nigeria, excluding it's conflict of rules, shall govern
          this Agreement and your use of our service. Your use of our service
          may also be subject to other local, state, national or international
          laws.
        </div>
        <div className="text-2xl font-[600] text-[#34B3EB]">VI. Security</div>
        <div className="">
          Snappy-fix technologies is concerned with safeguarding your Personal
          Information. We employ reasonable administrative, physical, and
          electronic measures designed to help protect your information from
          unauthorized access. No security, however, can eliminate the
          possibility that your Personal Information may be accessed by an
          unauthorized third party and we cannot guarantee that your Personal
          Information will remain secure in all situations.
        </div>
        <div className="">
          We will make any legally required disclosures of any breach of the
          security, confidentiality, or integrity of your unencrypted
          electronically stored “personal data” (as defined in applicable state
          statutes on security breach notification) to you via email, mail,
          telephone, or conspicuous posting on our website in the most expedient
          time possible and without unreasonable delay, insofar as consistent
          with (i) the legitimate needs of law enforcement or (ii) any measures
          necessary to determine the scope of the breach and restore the
          reasonable integrity of the data system. We reserve the right to
          choose which method we use to contact you about such an event.
        </div>
        <div className="text-2xl font-[600] text-[#34B3EB]">
          VII. Our Policy Toward Children
        </div>
        <div className="">
          The Services are not directed to children under 3. We do not knowingly
          collect Personal Information from children under 3.
          {/* If we
          become aware that a child under 18 has provided us with Personal
          Information, we will delete such information from our files. */}
        </div>
        {/* <div className="">
          Where the General Data Protection Regulation applies, our Services are
          not intended for children and we do not knowingly process Personal
          Information relating to children under the age of 13.
        </div> */}
        <div className="text-2xl font-[600] text-[#34B3EB]">VIII. Phishing</div>
        <div className="">
          Identity theft and the practice currently known as “phishing” are of
          great concern to Snappy-fix technologies. Safeguarding information to
          help protect you from identity theft is a top priority. We do not and
          will not, at any time, request your credit card information, your
          account ID, login password, or national identification numbers in a
          non-secure or unsolicited e-mail or telephone communication.
        </div>
        <div className="text-2xl font-[600] text-[#34B3EB]">
          IX. Change of our Privacy Policy
        </div>
        <div className="">
          If we decide to change our Privacy Policy, we will post those changes
          on this page or update the Privacy Policy modification date
        </div>
        <div className="text-2xl font-[600] text-[#34B3EB]">X. Complaints</div>
        <div className="">
          If you have any complaints concerning Snappy-fix technologies
          processing of your Personal Information, please contact us.
        </div>
        <div className="text-2xl font-[600] text-[#34B3EB]">
          XI. Child Safety
        </div>
        <div className="">
          Bible Compass is designed to provide access to Bible scriptures, study
          tools, and Christian resources for users of all ages. We are committed
          to maintaining a safe environment for children and families. Our app
          does not knowingly collect personal information from children. Bible
          Compass does not include features related to gambling, dating,
          financial services, or any form of real-money transactions. The
          content provided in the app is intended for educational and spiritual
          purposes only. We take reasonable measures to ensure that the app
          remains safe and appropriate for users, including children. If you
          believe that a child has provided personal information through our app
          without parental consent, please contact us so we can take appropriate
          steps to remove such information.
        </div>
      </div>
    </section>
  );
};

export default PrivacyBody;
